(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfl-signup-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nfl-signup-popup')) {
    customElements.define('nfl-signup-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.teaser = this.querySelector('[data-popup-open]');
        this.panels = [...this.querySelectorAll('[data-popup-panel]')];
        this.choices = [...this.querySelectorAll('[data-popup-method]')];
        if (!this.dialog || this.panels.length !== 2) return;
        this.storageKey = this.dataset.storageKey;
        this.preview = this.dataset.designMode === 'true' || new URLSearchParams(location.search).get('nfl_popup_preview') === '1';
        this.choices.forEach(button => button.addEventListener('click', () => this.selectMethod(button.dataset.popupMethod), options));
        this.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.teaser.addEventListener('click', () => this.open(), options);
        this.dialog.addEventListener('close', () => this.dismiss(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.addEventListener('shopify:section:select', () => this.open(), options);
        const params = new URLSearchParams(location.search);
        this.completed = params.get('nfl_signup') === 'success';
        if (this.completed) this.remember('completed', Date.now());
        this.dismissed = this.readState();
        this.startedAt = Date.now();
        this.delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
        if (this.preview) this.open();
        this.checkForms();
        this.poll = setInterval(() => this.checkForms(), 1000);
        this.stopPoll = setTimeout(() => clearInterval(this.poll), 45000);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearInterval(this.poll);
        clearTimeout(this.stopPoll);
      }
      hasContactInput(root) {
        if (root.querySelector('input[type="email"], input[inputmode="email"], input[type="tel"]')) return true;
        for (const child of root.querySelectorAll('*')) {
          if (child.shadowRoot && this.hasContactInput(child.shadowRoot)) return true;
        }
        return false;
      }
      checkForms() {
        const ready = this.panels.map(panel => {
          const loaded = this.hasContactInput(panel);
          panel.querySelector('[data-popup-unavailable]').hidden = loaded;
          return loaded;
        });
        if (!ready.every(Boolean) || this.completed || this.dismissed.completed) return;
        this.teaser.hidden = false;
        if (this.autoShown || this.preview) return;
        const ttl = Math.max(1, Number(this.dataset.dismissDays) || 7) * 86400000;
        if (Date.now() - (this.dismissed.dismissed || 0) < ttl) return;
        if (Date.now() - this.startedAt < this.delay) return;
        if (document.querySelector('dialog[open], cart-drawer[open]')) return;
        this.autoShown = true;
        this.open();
      }
      selectMethod(method) {
        this.choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.popupMethod === method)));
        this.panels.forEach(panel => { panel.hidden = panel.dataset.popupPanel !== method; });
        this.checkForms();
      }
      open() {
        if (!this.dialog.open) this.dialog.showModal();
        this.teaser.hidden = true;
      }
      dismiss() {
        if (!this.preview) {
          this.remember('dismissed', Date.now());
          this.dismissed = this.readState();
        }
        this.teaser.hidden = this.completed || Boolean(this.dismissed.completed) || !this.panels.every(panel => this.hasContactInput(panel));
      }
      readState() {
        try { return JSON.parse(localStorage.getItem(this.storageKey) || '{}') || {}; } catch { return {}; }
      }
      remember(key, value) {
        try { localStorage.setItem(this.storageKey, JSON.stringify({ ...this.readState(), [key]: value })); } catch {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
